import MediaUploader from 'actions/media/utils/MediaUploader';
import ProfileImageActions from 'actions/media/ProfileImageActions';
import { AA, Method, Resource } from 'sdk';

class ProfileImageActionCreator {
  // Uploading a new image involves three steps:
  // MediaUploader.uploadNewMediaToS3
  //   1) Get S3 parameters and a new profileImageId from AIVS
  //   2) Upload the image file to an initial upload bucket in S3
  // _putToAIVS
  //   3) PUT the new profileImageId to AIVS to verify the initial upload,
  //      update GAC tables, and, if approved, publish to Sable for access by clients
  create(params) {
    MediaUploader.uploadNewMediaToS3(params)
      .then(profileImageId => this.putToAIVS(params.amazonAuthorId, profileImageId))
      .then(
        (response) => {
          ProfileImageActions
            .createSucceeded({ amazonAuthorId: params.amazonAuthorId, response: response.data });
        },
        (error) => {
          ProfileImageActions.createFailed(error);
        },
      );
  }

  delete(amazonAuthorId) {
    AA.api(Resource.profileImage(amazonAuthorId), Method.delete).then(() => {
      ProfileImageActions.deleteSucceeded(amazonAuthorId);
    }, (error) => {
      ProfileImageActions.deleteFailed(error);
    });
  }

  fetch(amazonAuthorId) {
    AA.api(Resource.profileImage(amazonAuthorId), Method.get).then((response) => {
      ProfileImageActions.fetchSucceeded({ amazonAuthorId, response: response.data });
    }, (error) => {
      ProfileImageActions.fetchFailed(error);
    });
  }

  putToAIVS(amazonAuthorId, profileImageId) {
    return new Promise((resolve, reject) => {
      AA.api(
        Resource.profileImage(amazonAuthorId),
        Method.put,
        { profileImageId },
      ).then(resolve, reject);
    });
  }
}

export default new ProfileImageActionCreator();
